export const idFromGlobalId = globalId => {
	return Number(atob(globalId).split(':')[1]);
};

export const typeFromGlobalId = globalId => {
	return atob(globalId).split(':')[0];
};
